import { Pivot } from './pivot.model';

export class Report {

    reportId: number;
    reportName: string;
    lastUpdatedDate: string;
    createdUserId: number;
    createdUserName: string;
    updatedUserId: number;
    updatedUserName: string;
    reportConfig: Pivot;
    isPlayground: boolean;
    isShared: boolean;
    playgroundChanges: Array<any> = [];
    isPlaygroundChangesLoading: boolean = false;

    constructor() { }
}
